<tiime-overlay [isLoading]="loading()">
  <div tiimeOverlayHeader>Date de la prochaine relance</div>
  <div tiimeOverlayContent>
    <tiime-input-container
      contentId="next-reminder-date"
      [errorMessage]="nextReminderDateErrorMessage?.message"
      label="Date de la prochaine relance"
    >
      <input
        id="next-reminder-date"
        type="text"
        placeholder="Date"
        autocomplete="off"
        [formControl]="nextReminderDateCtrl"
        [matDatepicker]="datePicker"
        [min]="nextReminderDateMin()"
        [max]="nextReminderDateMax()"
      />
      <mat-icon
        color="primary"
        class="calendar-icon"
        fontSet="fontastic"
        fontIcon="icon-calendar"
        tiimeSuffix
        (click)="datePicker.open()"
      ></mat-icon>
      <mat-datepicker
        panelClass="tiime-material-datepicker"
        [calendarHeaderComponent]="tiimeDatepickerHeader"
        #datePicker
      ></mat-datepicker>
    </tiime-input-container>
  </div>
  <div tiimeOverlayFooter>
    <button type="button" tiime-button color="accent" raised (click)="updateNextReminderDate()">Modifier</button>
  </div>
</tiime-overlay>
